export default __webpack_public_path__ + "static/media/phone_white_18dp.482d3cfb.svg";